export const SidebarItems = Object.freeze({
    DASHBOARD: 'DASHBOARD',
    BUSINESS: 'BUSINESS',
    SIGNAL: 'SIGNAL',
    LEADS: 'LEADS',
    LANDING_PAGE: "LANDING_PAGE",
});